<div mat-dialog-content id="container"></div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
  <p>
    <em
      >Some content, may not be correctly styled in this preview but will be in
      the ASP App.</em
    >
  </p>
  <button mat-button (click)="onClose()">Close</button>
</div>
